import { Headline, Layout, ProfileCard, ProfileInfo } from "../../components";
import { ProfileController } from "../../controllers";
import { LinearProgress } from "@mui/material";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";

class Profile extends ProfileController {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        const {loading} = this.state;
        const {userData} = this.props;
 
        return (
            <Layout title="حساب کاربری ">
                <Helmet>
        <title> حساب کاربری  | بیمه زندگی هامرز</title>
      </Helmet>
                {loading ? 
                <LinearProgress />
                :
                <div className="profile scrollbar">
                    <div className="profile-container border">
                        <ProfileCard email={userData?.email} image={userData?.picture} name={`${userData?.first_name} ${userData?.last_name}`} position={userData?.brag_type} />
                        
                    </div>
                   
                    <div className="profile-info-container border">
                        <Headline isBold title=" اطلاعات هویتی" />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6 mt-3" title="نام و نام خانوادگی" value={`${userData?.first_name || ""}  ${userData?.last_name || ""}`} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="کد ملی" value={userData?.national_code} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="تاریخ تولد" value={userData?.birthdate || ""} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="نام پدر" value={userData?.father_name} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شماره همراه" value={userData?.phone} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شماره ثابت" value="---" />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="شغل فعلی" value={userData?.job} />
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="مدرک تحصیلی" value={userData?.education_degree}/>
                        <ProfileInfo myStyle="col-lg-3 col-sm-6 col-6" title="جنسیت" value={userData?.gender ? "مرد" : "زن"} />
                        <ProfileInfo myStyle="col-lg-6 col-md-12" title="آدرس" value={userData?.address}/>
                    </div>
                   

                </div>
                        }
            </Layout>
        )
    }
}


const mapStateToProps = (dispatch:any) => {
    return {
      dispatch,
      userData:dispatch.general.userData,
    }
  };
  
  export default connect(mapStateToProps)(Profile);